import { render, staticRenderFns } from "./StartupManagementParent.vue?vue&type=template&id=9170b732"
import script from "./StartupManagementParent.vue?vue&type=script&lang=js"
export * from "./StartupManagementParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports